module.exports = __webpack_public_path__ + "static/media/gefaess_mit.fa30c7c4.jpg";